import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';

import If from '../../shared/If';
import Box from '../../shared/Box';
import Text from '../../shared/Text';
import Spinner from '../../components/Spinner';

import styles from './SupportersCancelScreen.sass';

const SupportersCancelScreen = ({
  podcastName,
  podcastUrl,
  cancelCode,
  isPageLoading,
  podcastStationId,
  onClickCancel,
  isCancelComplete,
  isCancellationProcessing,
}) => (
  <div className={styles.root}>
    <div className={styles.content}>
      <If
        condition={isPageLoading}
        ifRender={() => (
          <Box>
            <Text size="xl" align="center">
              Loading...
            </Text>
          </Box>
        )}
        elseRender={() => (
          <React.Fragment>
            <div className={styles.title}>
              Stop supporting{' '}
              <span className={styles.podcastTitle}>{podcastName}</span>
            </div>
            <If
              condition={isCancelComplete}
              ifRender={() => (
                <div className={styles.bodyText}>
                  We've canceled your subscription. If you ever want to support
                  this podcast again in the future, you can always sign up again
                  from their profile at{' '}
                  <span className={styles.podcastUrl}>{podcastUrl}</span>
                </div>
              )}
              elseRender={() => (
                <React.Fragment>
                  <div className={styles.bodyText}>
                    If you'd like to stop supporting this podcast, just click
                    Cancel. You won't be charged again going forward.
                  </div>
                  <Button
                    type="submit"
                    bsStyle="primary"
                    disabled={isCancellationProcessing}
                    bsClass={styles.cancelButton}
                    onClick={() => {
                      onClickCancel(podcastStationId, cancelCode);
                    }}
                  >
                    <If
                      condition={isCancellationProcessing}
                      ifRender={() => <Spinner size={18} />}
                      elseRender={() => <span>Cancel my subscription</span>}
                    />
                  </Button>
                </React.Fragment>
              )}
            />
          </React.Fragment>
        )}
      />
    </div>
  </div>
);

SupportersCancelScreen.propTypes = {
  podcastName: PropTypes.string.isRequired,
  podcastUrl: PropTypes.string.isRequired,
  cancelCode: PropTypes.string.isRequired,
  podcastStationId: PropTypes.string.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  isCancelComplete: PropTypes.bool.isRequired,
  isCancellationProcessing: PropTypes.bool.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
};

export default SupportersCancelScreen;
